import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Card,
  Grid,
  TextField,
  FormHelperText,
  IconButton,
  List,
  ListItem,
  Icon,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tab,
  Stack,
  ListItemButton,
  Button,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MDButton from "components/MDButton";
// import DeleteIcon from "@mui/icons-material/Delete";
import DeleteIcon from "common/customIcons/delete";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CommonQuillEditor from "common/editor";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import DragIcon from "common/customIcons/dragIcon";
import EditIcon from "common/customIcons/edit";
import { openCustomModalDialog } from "../../../../redux/slices/modalSlice";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import EditableAccordionHeader from "../components/EditableAccordionHeader";

function FooterSection({
  footerOpen,
  setFooterOpen,
  formData,
  setFormData,
  errors,
  setErrors,
  handleFooterTabChange,
  footerTab,
  handleAddCta,
  handleRemoveCta,
  handleRemoveItem,
  activeItem,
  handleSaveItem,
  draftItem,
  setDraftItem,
  activeItemIndex,
  setActiveItemIndex,
  selectedMenu,
  menuNameError,
  newLocationName,
  newLocationId,
  locationPageList,
  addLocationHandler,
  isEdit,
  newLocationLink,
  setMenuNameError,
  handleDragEnd,
  dispatch,
  handleAddItems,
  handleEditItem,
  handleToggleActive,
  overViewPageList,
  setOverViewPageList,
  setNewLocationName,
  setNewLocationLink,
  setNewLocationId,
  setIsEdit,
  setEditingLocationId,
  handleRemoveLocation,
  // Heading editing props
  sectionHeading,
  isEditingHeading,
  tempHeadingValue,
  setTempHeadingValue,
  onEditHeading,
  onSaveHeading,
  onCancelHeading,
}) {
  return (
    <Accordion
      className="home-page-faq"
      style={{ marginBottom: "16px" }}
      expanded={footerOpen}
      onChange={() => setFooterOpen(!footerOpen)}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panelFooter-content"
        id="panelFooter-header"
      >
        <EditableAccordionHeader
          sectionKey="footerSection"
          heading={sectionHeading}
          isEditing={isEditingHeading}
          tempValue={tempHeadingValue}
          setTempValue={setTempHeadingValue}
          onEdit={onEditHeading}
          onSave={onSaveHeading}
          onCancel={onCancelHeading}
        />
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ width: "100%" }}>
          <Card
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 2.5,
              boxShadow: "none",
              backgroundColor: "#F5F5FF",
              marginBottom: "30px",
              position: "relative",
            }}
            className="footer-tabs"
          >
            <Box display="flex" flexDirection="column" gap={1}>
              <Card
                sx={{
                  p: { xs: 2, md: 3 },
                  borderRadius: 2.5,
                  boxShadow: "none",
                  backgroundColor: "#ffffff",
                  position: "relative",
                }}
              >
                <Grid container direction="row" spacing={2}>
                  {formData?.footerSection?.overView?.cta?.map((item, index) => (
                    <Grid item xs={12} key={index}>
                      <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="#9A9AAF"
                              mb={1}
                              style={{ fontSize: "14px" }}
                            >
                              CTA
                            </Typography>
                            <TextField
                              className="form-input"
                              fullWidth
                              placeholder="CTA URL"
                              name="overView_cta1_label"
                              value={item?.label || ""}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prev) => ({
                                  ...prev,
                                  footerSection: {
                                    ...prev.footerSection,
                                    overView: {
                                      ...prev.footerSection.overView,
                                      cta: prev.footerSection.overView.cta.map((cta, i) =>
                                        i === index ? { ...cta, label: value } : cta
                                      ),
                                    },
                                  },
                                }));
                              }}
                            />
                          </Box>
                          <FormControl component="fieldset" className="mt-1">
                            <FormControlLabel
                              label="Open a new tab"
                              labelPlacement="on"
                              control={
                                <Switch
                                  color="primary"
                                  checked={Boolean(item?.openNewTab)}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setFormData((prev) => ({
                                      ...prev,
                                      footerSection: {
                                        ...prev.footerSection,
                                        overView: {
                                          ...prev.footerSection.overView,
                                          cta: prev.footerSection.overView.cta.map((cta, i) =>
                                            i === index ? { ...cta, openNewTab: checked } : cta
                                          ),
                                        },
                                      },
                                    }));
                                  }}
                                />
                              }
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="#9A9AAF"
                              mb={1}
                              style={{ fontSize: "14px" }}
                            >
                              CTA Link
                            </Typography>
                            {overViewPageList ?
                               <FormControl fullWidth className="add-location-link">
                               <InputLabel>CTA Link</InputLabel>
                               <Select
                                 value={item?.url || ""}
                                 name="overviewUrl"
                                 onChange={(e) => {
                                   const selected = e.target.value;
                                   setFormData((prev) => ({
                                    ...prev,
                                    footerSection: {
                                      ...prev.footerSection,
                                      overView: {
                                        ...prev.footerSection.overView,
                                        cta: prev.footerSection.overView.cta.map((cta, i) =>
                                          i === index ? { ...cta, url: selected } : cta
                                        ),
                                      },
                                    },
                                  }));
                                   
                                 }}
                                 className="form-select"
                                 MenuProps={{
                                   style: {
                                     height: 400,
                                   },
                                 }}
                                 label={"https://hyperwolf.com/w/cannabis-delivery..."}
                                //  error={Boolean(errors.locationLink)}
                                 displayEmpty
                                 renderValue={(selected) => {
                                  //  const selectedOption = locationPageList?.data?.find(
                                  //    (option) => option._id === selected
                                  //  );
                                  //  return selectedOption?.canonical || newLocationLink || "";
                                 }}
                               >
                                 {/* {locationPageList?.data?.length > 0 &&
                                   locationPageList?.data?.map((option, idx) => {
                                     return (
                                       <MenuItem value={option._id} key={idx + 1}>
                                         {option?.city}
                                       </MenuItem>
                                     );
                                   })} */}
                               </Select>
                             </FormControl>
                            :
                            <TextField
                              className="form-input"
                              fullWidth
                              placeholder="https://..."
                              value={item?.url || ""}
                              name="overView_cta1_url"
                              onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prev) => ({
                                  ...prev,
                                  footerSection: {
                                    ...prev.footerSection,
                                    overView: {
                                      ...prev.footerSection.overView,
                                      cta: prev.footerSection.overView.cta.map((cta, i) =>
                                        i === index ? { ...cta, url: value } : cta
                                      ),
                                    },
                                  },
                                }));
                              }}
                            />}
                            {/* <Select
                          value=""
                          name=""
                          className="form-select"
                          MenuProps={{
                            style: {
                              height: 400,
                            },
                          }}
                          label=""
                          fullWidth
                        >
                          <MenuItem value="" key="">
                            About Us
                          </MenuItem>
                          <MenuItem value="" key="">
                            Contact Us
                          </MenuItem>
                        </Select> */}
                          </Box>
                          <FormControl component="fieldset" className="mt-1">
                            <FormControlLabel
                              style={{
                                display: "flex",
                                flexDirection: "row-reverse",
                                margin: "0",
                              }}
                              value="on"
                              label="Select from page list"
                              // control={<Switch color="primary" />}
                              control={
                                <Switch
                                  color="primary"
                                  checked={Boolean(overViewPageList)}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setOverViewPageList(checked)
                                  }
                                  }
                                />}
                              labelPlacement="on"
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <Box display="flex" justifyContent="end">
                            <IconButton
                              onClick={() => handleRemoveCta(index)}
                              sx={{
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                              color="error"
                              size="small"
                              variant="primary"
                            >
                              <DeleteIcon width="16px" height="16px" />
                            </IconButton>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                  ))}

                  <Grid item xs={12}>
                    <MDButton
                      type="button"
                      color="primary"
                      size="medium"
                      variant="outlined"
                      sx={{ minWidth: "110px", fontSize: "14px" }}
                      onClick={handleAddCta}
                    >
                      <Icon>add</Icon>&nbsp;Add
                    </MDButton>
                  </Grid>

                  <Grid item xs={12}>
                    <Box>
                      <Typography
                        variant="body2"
                        fontWeight="medium"
                        color="#9A9AAF"
                        mt={3}
                        mb={1}
                        style={{ fontSize: "14px" }}
                      >
                        LICENSE Paragraph
                      </Typography>
                      <CommonQuillEditor
                        value={formData?.footerSection?.overView?.description || ""}
                        error={!!errors?.overView_desc}
                        name="overView_desc"
                        onChange={(val) => {
                          setErrors((prev) => ({ ...prev, overView_desc: "" }));
                          setFormData((prev) => ({
                            ...prev,
                            footerSection: {
                              ...prev.footerSection,
                              overView: {
                                ...prev.footerSection.overView,
                                description: val,
                              },
                            },
                          }));
                        }}
                      />
                      {Boolean(errors.overView_desc) && (
                        <FormHelperText error>{errors.overView_desc}</FormHelperText>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Card>
            </Box>
          </Card>

          <Card
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 2.5,
              boxShadow: "none",
              backgroundColor: "#F5F5FF",
              marginBottom: "30px",
              position: "relative",
            }}
            className="footer-tabs"
          >
            <Box display="flex" flexDirection="column" gap={1}>
              <Card
                sx={{
                  p: { xs: 2, md: 3 },
                  borderRadius: 2.5,
                  boxShadow: "none",
                  backgroundColor: "#ffffff",
                  position: "relative",
                }}
              >
                <TabContext value={footerTab}>
                  <Box display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                    <Box>
                      <TabList aria-label="lab API tabs example" onChange={handleFooterTabChange}>
                        {Object.entries(formData.footerSection.menusItems).map(([menuKey, item]) => (
                          <Tab
                            key={menuKey}
                            label={
                              <Typography
                                variant="body2"
                                fontWeight="600"
                                color="#8A8A98"
                                style={{ fontSize: "14px" }}
                              >
                                {item.name}
                              </Typography>
                            }
                            value={menuKey}
                          />
                        ))}
                        {/* {console.log(selectedMenu?.isActive, "asdfasfasdfasf")} */}
                      </TabList>
                    </Box>
                    {/* <Stack
                      direction="row"
                      alignItems="center"
                      gap={0.75}
                      lineHeight={1}
                      p={0.75}
                      borderRadius={2}
                      bgcolor="#ffffff"
                      className="modal-add-banner-btns"
                      sx={{ marginLeft: "auto" }}
                    >
                      <MDButton
                        sx={{
                          minWidth: "92px",
                          borderRadius: 1.75,
                          minHeight: "28px",
                          p: 0.25,
                          fontWeight: 500,
                          // backgroundColor: selectedMenu?.isActive ? `#24ca49 !important` : "dark",
                        }}
                        variant={selectedMenu?.isActive ? "contained" : "text"}
                        color={selectedMenu?.isActive ? "success" : "dark"}
                        // variant={formData?.status === "active" ? "contained" : "text"}
                        // color={formData?.status === "active" ? "success" : "dark"}
                        type="button"
                        size="small"
                        onClick={() => {
                          if (!selectedMenu) return;
                          handleToggleActive(footerTab, true);
                        }}
                      >
                        Active
                      </MDButton>

                      <MDButton
                        sx={{
                          minWidth: "92px",
                          borderRadius: 1.75,
                          minHeight: "28px",
                          p: 0.25,
                          fontWeight: 500,
                          // backgroundColor: !selectedMenu?.isActive
                          //   ? "#fd4438 !important"
                          //   : "dark",
                        }}
                        variant={!selectedMenu?.isActive ? "contained" : "text"}
                        color={!selectedMenu?.isActive ? "error" : "dark"}
                        // variant={formData?.status !== "active" ? "contained" : "text"}
                        // color={formData?.status !== "active" ? "error" : "dark"}
                        type="button"
                        size="small"
                        onClick={() => {
                          if (!selectedMenu) return;
                          handleToggleActive(footerTab, false);
                        }}
                      >
                        Inactive
                      </MDButton>
                    </Stack> */}
                  </Box>

                  <TabPanel value={footerTab} style={{ padding: "30px 0 0 0" }}>
                    <Grid container direction="row" spacing={4}>
                      <Grid item xs={12}>
                        <Box display="flex" flexDirection="column" gap={2}>
                          <Box sx={{ width: "380px" }}>
                            <Typography
                              variant="body2"
                              fontWeight="medium"
                              color="#9A9AAF"
                              mb={1}
                              style={{ fontSize: "14px" }}
                            >
                              Menu Title (H4)
                            </Typography>
                            <TextField
                              className="form-input"
                              fullWidth
                              placeholder="Menu Title (H4)"
                              value={selectedMenu?.name || ""}
                              error={Boolean(menuNameError[footerTab])}
                              helperText={menuNameError[footerTab]}
                              onChange={(e) => {
                                const value = e.target.value;

                                setMenuNameError((prev) => ({
                                  ...prev,
                                  [footerTab]: value.trim() === "" ? "Menu Title is required" : "",
                                }));

                                if (!selectedMenu) return;

                                setFormData((prev) => ({
                                  ...prev,
                                  footerSection: {
                                    ...prev.footerSection,
                                    menusItems: {
                                      ...prev.footerSection.menusItems,
                                      [footerTab]: {
                                        ...prev.footerSection.menusItems[footerTab],
                                        name: value,
                                      },
                                    },
                                  },
                                }));
                              }}
                            />
                          </Box>
                          <Box display="flex" gap={4} className="w-100">
                            <Card
                              sx={{
                                p: { xs: 2 },
                                borderRadius: 2.5,
                                boxShadow: "none",
                                backgroundColor: "#F5F5FF",
                                margin: "0",
                                position: "relative",
                                width: "380px",
                              }}
                            >
                              <DragDropContext onDragEnd={handleDragEnd}>
                                <Droppable droppableId="footer-menu-items">
                                  {(provided) => (
                                    <List
                                      {...provided.droppableProps}
                                      ref={provided.innerRef}
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                        gap: "8px",
                                        padding: "0",
                                        cursor: "auto",
                                      }}
                                    >
                                      {selectedMenu?.subData?.map((item, index) => (
                                        <Draggable
                                          key={item.id || index}
                                          draggableId={item.id || `item-${index}`}
                                          index={index}
                                        >
                                          {(provided, snapshot) => (
                                            <ListItem
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={{
                                                padding: "0",
                                                margin: "0",
                                                width: "100%",
                                                backgroundColor: snapshot.isDragging ? "#f9f9f9" : "#ffffff",
                                                // border: '1px solid #e0e0e0',
                                                borderRadius: '12px',
                                                display: "flex",
                                                alignItems: "center",
                                                // gap: '12px',
                                                ...provided.draggableProps.style,
                                              }}
                                            >
                                              <ListItemButton
                                                onClick={() => setActiveItemIndex(index)}
                                                style={{
                                                  gap: "16px",
                                                  margin: "0",
                                                  background: "#ffffff",
                                                  borderRadius: "12px",
                                                  padding: "12px",
                                                  cursor: "auto",
                                                }}
                                              >
                                                <DragIcon style={{ color: "#666666" }} />
                                                {item.icon && (
                                                  <img
                                                    src={item.icon}
                                                    alt={item.label}
                                                    style={{ width: "20px", height: "20px", objectFit: "contain" }}
                                                  />
                                                )}
                                                <span>{item.label}</span>
                                                <Box
                                                  sx={{
                                                    position: "absolute",
                                                    top: 5,
                                                    right: 8,
                                                    zIndex: 1,
                                                  }}
                                                >
                                                  {/* <IconButton
                                                    onClick={() => {
                                                      dispatch(
                                                        openCustomModalDialog({
                                                          modal: "ADD_ITEMS",
                                                          modalData: {
                                                            onSubmit: handleEditItem,
                                                            footerTab,
                                                            itemData: item, // Passing the selected item to the modal
                                                          },
                                                        })
                                                      );
                                                    }}
                                                    sx={{
                                                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                      "&:hover": {
                                                        backgroundColor: "rgba(255, 255, 255, 1)",
                                                      },
                                                    }}
                                                    color="primary"
                                                    size="small"
                                                  >
                                                    <EditIcon width="16px" height="16px" />
                                                  </IconButton> */}
                                                  {/* <IconButton
                                                    onClick={() =>
                                                      handleRemoveItem(selectedMenu.subData, index)
                                                    }
                                                    sx={{
                                                      backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                      "&:hover": {
                                                        backgroundColor: "rgba(255, 255, 255, 1)",
                                                      },
                                                    }}
                                                    color="error"
                                                    size="small"
                                                  >
                                                    <DeleteIcon width="16px" height="16px" />
                                                  </IconButton> */}
                                                  <Switch
                                                    color="primary"
                                                    checked=""
                                                  />
                                                </Box>
                                              </ListItemButton>
                                            </ListItem>
                                          )}
                                        </Draggable>
                                      ))}
                                      {provided.placeholder}
                                    </List>
                                  )}
                                </Droppable>
                              </DragDropContext>

                              <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                                <MDButton
                                  type="button"
                                  color="primary"
                                  size="medium"
                                  variant="outlined"
                                  sx={{ minWidth: "130px", fontSize: "14px", padding: "0" }}
                                  onClick={() =>
                                    // dispatch(
                                    //   openCustomModalDialog({
                                    //     modal: "ADD_ITEMS",
                                    //     modalData: {
                                    //       onSubmit: handleAddItems,
                                    //       footerTab,
                                    //     },
                                    //   })
                                    // )
                                   setActiveItemIndex(selectedMenu?.subdata?.length() + 1)
                                  }
                                >
                                  <Icon>add</Icon>&nbsp;Add Item
                                </MDButton>
                              </Box>
                            </Card>

                            {activeItemIndex !== null && (
                              <Box  display="flex" flexDirection="column" gap={2}
                                sx={{
                                  backgroundColor: "#ffffff",
                                  minHeight: "100%",
                                  width: "100%",
                                  maxWidth: "500px"
                                }}
                              >
                                {/* Add Icon */}
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight="medium"
                                    color="#9A9AAF"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Add Icon
                                  </Typography>
                                  <Box display="flex" alignItems="start" gap={1}>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="20px"
                                      backgroundColor="#F1F1F1"
                                      width="110px"
                                      height="110px"
                                      sx={{
                                        // border: error.icon ? "1px solid red" : "none",
                                        cursor: "pointer",
                                        "&:hover": {
                                          filter: "blur(.5px)",
                                        },
                                      }}
                                    >
                                      <div className="add-change-img-sec" style={{ textAlign: "center" }}>
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="25"
                                          viewBox="0 0 24 25"
                                          fill="none"
                                        >
                                          <g clipPath="url(#clip0_26193_49200)">
                                            <path
                                              d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                              fill="#2E2E3A"
                                            />
                                          </g>
                                          <defs>
                                            <clipPath id="clip0_26193_49200">
                                              <rect width="24" height="25" fill="white" />
                                            </clipPath>
                                          </defs>
                                        </svg>
                                        <Typography
                                          variant="body2"
                                          fontWeight="600"
                                          color="#2E2E3A"
                                          style={{ fontSize: "12px" }}
                                        >
                                          Upload File
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          fontWeight="400"
                                          color="#2E2E3A"
                                          style={{ fontSize: "12px" }}
                                        >
                                          20x20
                                        </Typography>
                                      </div>
                                    </Box>
                                    <Box
                                      display="flex"
                                      alignItems="center"
                                      justifyContent="center"
                                      borderRadius="20px"
                                      backgroundColor="#F1F1F1"
                                      width="110px"
                                      height="110px"
                                      sx={{
                                        // border: error.icon ? "1px solid red" : "none",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        id={"file-input"}
                                        style={{ display: "none" }}
                                        // onChange={(e) => {
                                        //   setError((prev) => ({ ...prev, icon: "" }));
                                        //   handleFileChange(e);
                                        // }}
                                      />
                                      <MDButton
                                        sx={{ minWidth: "180px" }}
                                        type="button"
                                        variant="outlined"
                                        color="secondary"
                                        component="span"
                                        // onClick={(e) => {
                                        //   document.getElementById("file-input").click(), e.currentTarget.blur();
                                        // }}
                                        style={{
                                          padding: "0",
                                          border: "none",
                                          borderRadius: "0",
                                        }}
                                      >
                                        <div className="add-change-img-sec">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="25"
                                            viewBox="0 0 24 25"
                                            fill="none"
                                          >
                                            <g clipPath="url(#clip0_26193_49200)">
                                              <path
                                                d="M14.2274 15.8545C14.1173 15.8547 14.0086 15.8296 13.9089 15.781C13.8093 15.7324 13.7211 15.6615 13.6508 15.5733L12.7504 14.4479V21.8603C12.7504 22.0675 12.6714 22.2662 12.5308 22.4127C12.3901 22.5592 12.1993 22.6416 12.0004 22.6416C11.8015 22.6416 11.6107 22.5592 11.4701 22.4127C11.3294 22.2662 11.2504 22.0675 11.2504 21.8603V14.4479L10.35 15.5733C10.2872 15.6529 10.2099 15.7187 10.1226 15.767C10.0352 15.8153 9.93958 15.8452 9.84113 15.8548C9.74267 15.8645 9.64336 15.8538 9.5489 15.8233C9.45444 15.7928 9.36669 15.7431 9.29072 15.6772C9.21475 15.6113 9.15205 15.5303 9.10623 15.439C9.0604 15.3477 9.03236 15.2479 9.02372 15.1453C9.01508 15.0427 9.026 14.9393 9.05586 14.8411C9.08572 14.7429 9.13393 14.6518 9.19772 14.5731L11.4243 11.7899C11.4947 11.7019 11.5828 11.6311 11.6823 11.5825C11.7819 11.5339 11.8905 11.5088 12.0005 11.5088C12.1104 11.5088 12.219 11.5339 12.3186 11.5825C12.4182 11.6311 12.5063 11.7019 12.5767 11.7899L14.8032 14.5731C14.8945 14.6871 14.9526 14.8259 14.9709 14.9731C14.9891 15.1204 14.9667 15.27 14.9063 15.4044C14.8459 15.5389 14.75 15.6526 14.6297 15.7323C14.5095 15.812 14.37 15.8544 14.2275 15.8545H14.2274ZM22.8011 10.8044C22.1571 9.92076 21.2996 9.23086 20.316 8.80513C20.2817 7.43372 19.8323 6.10864 19.0322 5.01895C18.1059 3.76256 16.7356 2.87852 15.1739 2.52965C11.3639 1.67882 7.26309 4.1002 6.03267 7.9274L5.89955 8.34156C4.32962 8.35074 2.82723 9.00795 1.72172 10.1691C0.616204 11.3303 -0.00223194 12.9007 0.00197444 14.536C0.00618083 16.1714 0.632686 17.7383 1.74416 18.8933C2.85563 20.0483 4.36137 20.6971 5.93133 20.6975H9.36385C9.56276 20.6975 9.75352 20.6152 9.89418 20.4687C10.0348 20.3222 10.1138 20.1235 10.1138 19.9163C10.1138 19.7091 10.0348 19.5104 9.89418 19.3638C9.75352 19.2173 9.56276 19.135 9.36385 19.135H5.93133C4.75618 19.135 3.62916 18.6487 2.7982 17.7832C1.96725 16.9176 1.50042 15.7436 1.50042 14.5195C1.50042 13.2954 1.96725 12.1214 2.7982 11.2558C3.62916 10.3902 4.75618 9.90396 5.93133 9.90396H6.43936C6.5966 9.90396 6.74986 9.85248 6.87748 9.7568C7.0051 9.66112 7.10062 9.52607 7.15055 9.37076L7.45524 8.42349C8.45081 5.32657 11.7724 3.36793 14.8597 4.05748C17.3343 4.61011 18.9586 6.76744 18.8097 9.30381C18.7994 9.47937 18.8462 9.65343 18.9426 9.79781C19.0391 9.9422 19.1794 10.0485 19.341 10.0994C21.2011 10.6849 22.5004 12.5025 22.5004 14.5195C22.4991 15.7432 22.0318 16.9164 21.2012 17.7816C20.3705 18.6469 19.2443 19.1336 18.0695 19.135H14.637C14.4381 19.135 14.2473 19.2173 14.1067 19.3638C13.966 19.5104 13.887 19.7091 13.887 19.9163C13.887 20.1235 13.966 20.3222 14.1067 20.4687C14.2473 20.6152 14.4381 20.6975 14.637 20.6975H18.0695C19.6419 20.6957 21.1495 20.0442 22.2613 18.886C23.3732 17.7278 23.9986 16.1574 24.0004 14.5195C24.003 13.1776 23.5816 11.8721 22.8011 10.8044Z"
                                                fill="#2E2E3A"
                                              />
                                            </g>
                                            <defs>
                                              <clipPath id="clip0_26193_49200">
                                                <rect width="24" height="25" fill="white" />
                                              </clipPath>
                                            </defs>
                                          </svg>
                                          <Typography
                                            variant="body2"
                                            fontWeight="600"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            Change File
                                          </Typography>
                                          <Typography
                                            variant="body2"
                                            fontWeight="400"
                                            color="#2E2E3A"
                                            style={{ fontSize: "12px" }}
                                          >
                                            20x20
                                          </Typography>
                                        </div>
                                      </MDButton>
                                    </Box>
                                  </Box>
                                </Box>

                                {/* Main Menu Name */}
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight="medium"
                                    color="#9A9AAF"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    Main Menu Name
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    placeholder="Enter menu name"
                                    size="medium"
                                    // value={activeItem?.label}
                                    value={draftItem?.label || ""}
                                    // onChange={(e) => {
                                    //   const value = e.target.value;

                                    //   setFormData((prev) => ({
                                    //     ...prev,
                                    //     footerSection: {
                                    //       ...prev.footerSection,
                                    //       menusItems: {
                                    //         ...prev.footerSection.menusItems,
                                    //         [footerTab]: {
                                    //           ...prev.footerSection.menusItems[footerTab],
                                    //           subData: prev.footerSection.menusItems[
                                    //             footerTab
                                    //           ].subData.map((item, index) =>
                                    //             index === activeItemIndex
                                    //               ? { ...item, label: value }
                                    //               : item
                                    //           ),
                                    //         },
                                    //       },
                                    //     },
                                    //   }));
                                    // }}
                                    onChange={(e) =>
                                      setDraftItem((prev) => ({ ...prev, label: e.target.value }))
                                    }
                                  />

                                  <FormControl component="fieldset" className="mt-1">
                                    <FormControlLabel
                                      style={{
                                        display: "flex",
                                        flexDirection: "row-reverse",
                                        margin: "0",
                                      }}
                                      value="on"
                                      label="Select from page list"
                                      control={
                                        <Switch
                                          color="primary"
                                          checked={Boolean(draftItem?.openInNewTab)}
                                          onChange={(e) => {
                                            const checked = e.target.checked;
                                            setOverViewPageList(checked)
                                          }
                                          }
                                        />}
                                      labelPlacement="on"
                                    />
                                  </FormControl>
                                </Box>

                                {/* URL */}
                                <Box>
                                  <Typography
                                    variant="body2"
                                    fontWeight="medium"
                                    color="#9A9AAF"
                                    mb={1}
                                    style={{ fontSize: "14px" }}
                                  >
                                    URL
                                  </Typography>

                                  <TextField
                                    fullWidth
                                    placeholder="https://example.com"
                                    size="medium"
                                    // value={activeItem?.url}
                                    value={draftItem?.url || ""}
                                    // onChange={(e) => {
                                    //   const value = e.target.value;

                                    //   setFormData((prev) => ({
                                    //     ...prev,
                                    //     footerSection: {
                                    //       ...prev.footerSection,
                                    //       menusItems: {
                                    //         ...prev.footerSection.menusItems,
                                    //         [footerTab]: {
                                    //           ...prev.footerSection.menusItems[footerTab],
                                    //           subData: prev.footerSection.menusItems[
                                    //             footerTab
                                    //           ].subData.map((item, index) =>
                                    //             index === activeItemIndex ? { ...item, url: value } : item
                                    //           ),
                                    //         },
                                    //       },
                                    //     },
                                    //   }));
                                    // }}
                                    onChange={(e) =>
                                      setDraftItem((prev) => ({ ...prev, url: e.target.value }))
                                    }
                                  />

                                  {/* Open in new tab */}
                                  <FormControl component="fieldset" className="mt-1">
                                    <FormControlLabel
                                      label="Open a new tab"
                                      labelPlacement="on"
                                      control={
                                        <Switch
                                          color="primary"
                                          // checked={Boolean(activeItem?.openInNewTab)}
                                          checked={Boolean(draftItem?.openInNewTab)}
                                          // onChange={(e) => {
                                          //   const checked = e.target.checked;

                                          //   setFormData((prev) => ({
                                          //     ...prev,
                                          //     footerSection: {
                                          //       ...prev.footerSection,
                                          //       menusItems: {
                                          //         ...prev.footerSection.menusItems,
                                          //         [footerTab]: {
                                          //           ...prev.footerSection.menusItems[footerTab],
                                          //           subData: prev.footerSection.menusItems[
                                          //             footerTab
                                          //           ].subData.map((item, index) =>
                                          //             index === activeItemIndex
                                          //               ? { ...item, openInNewTab: checked }
                                          //               : item
                                          //           ),
                                          //         },
                                          //       },
                                          //     },
                                          //   }));
                                          // }}
                                          onChange={(e) =>
                                            setDraftItem((prev) => ({
                                              ...prev,
                                              openInNewTab: e.target.checked,
                                            }))
                                          }
                                        />
                                      }
                                    />
                                  </FormControl>
                                </Box>

                                <Box display="flex" gap={2}>
                                  <MDButton
                                    type="button"
                                    color="primary"
                                    // size="medium"
                                    variant="outlined"
                                    sx={{ minWidth: "130px", fontSize: "14px" }}
                                    onClick={handleSaveItem}
                                  >
                                    Save
                                  </MDButton>
                                  {/* <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSaveItem}
                                    sx={{
                                      textTransform: "none",
                                      borderRadius: "8px",
                                      fontWeight: 500,
                                    }}
                                    fullWidth
                                  >
                                    Save
                                  </Button> */}

                                  <MDButton
                                    type="button"
                                    variant="outlined"
                                    color="error"
                                    size="medium"
                                    sx={{ minWidth: "130px", fontSize: "14px" }}
                                    onClick={() => setActiveItemIndex(null)}
                                  >
                                    Cancel
                                  </MDButton>
                                </Box>
                              </Box>
                            )}
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </TabPanel>
                </TabContext>
              </Card>
            </Box>
          </Card>

          <Box>
            <Typography
              variant="body2"
              fontWeight="medium"
              color="#9A9AAF"
              mb={1}
              style={{ fontSize: "14px" }}
            >
              Government Warning Paragraph
            </Typography>
            <CommonQuillEditor
              value={formData.footerSection.paragraph}
              error={!!errors?.footerParagraph}
              disabled={true}
              onChange={(value) => {
                setErrors((prev) => ({
                  ...prev,
                  footerParagraph: "",
                }));
                setFormData((prev) => {
                  const updated = { ...prev };
                  updated.footerSection.paragraph = value;
                  return updated;
                });
              }}
            />
            {Boolean(errors.footerParagraph) && (
              <FormHelperText error>{errors.footerParagraph}</FormHelperText>
            )}
          </Box>

          <Card
            sx={{
              p: { xs: 2, md: 3 },
              borderRadius: 2.5,
              boxShadow: "none",
              backgroundColor: "#F5F5FF",
              position: "relative",
              marginTop: "30px",
            }}
            className="locations-card"
          >
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography
                  variant="body2"
                  fontWeight="medium"
                  color="#9A9AAF"
                  style={{ fontSize: "14px" }}
                // mb={1}
                >
                  Locations
                </Typography>
                <List
                  style={{
                    display: "grid",
                    flexDirection: "column",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr",
                    columnGap: "12px",
                    rowGap: "20px",
                    padding: "0",
                  }}
                >
                  {formData.footerSection?.locationList?.length === 0 && errors.locationList && (
                    <Typography
                      color="error"
                      sx={{ variant: "body2", mt: 1 }}
                      style={{ fontSize: "14px" }}
                    >
                      {errors.locationList}
                    </Typography>
                  )}

                  {formData.footerSection?.locationList?.map(
                    (location, index) =>
                      location.locationName && (
                        <ListItem
                          style={{
                            padding: "12px",
                            borderRadius: "12px",
                            background: "#ffffff",
                            justifyContent: "space-between",
                          }}
                          key={location.location_id || location._id || `location-${index}`}
                        >
                          <Typography
                            variant="body2"
                            fontWeight="400"
                            color="#2E2E3A"
                            style={{ fontSize: "14px" }}
                          >
                            {location.locationName}
                          </Typography>

                          <Box display="flex" gap={1} ml={1}>
                            <IconButton
                              onClick={(e) => {
                                const locationId = location.location_id || location._id;
                                setIsEdit(true);
                                setEditingLocationId(locationId);
                                setNewLocationName(location.locationName);
                                setNewLocationLink(location.locationLink);
                                // Find matching option from locationPageList by ID (location_id or _id)
                                const matchingOption = locationPageList?.data?.find(
                                  (option) =>
                                    option._id === locationId ||
                                    option._id === location.location_id ||
                                    option._id === location._id
                                );
                                // Set the ID from locationPageList if found, otherwise use the location's ID
                                // This ensures the Select component can display the selected value
                                setNewLocationId(matchingOption?._id || locationId || "");
                              }}
                              sx={{
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                              color="primary"
                              size="small"
                            >
                              <EditIcon width="16px" height="16px" />
                            </IconButton>

                            <IconButton
                              onClick={() =>
                                handleRemoveLocation(location.location_id || location._id)
                              }
                              sx={{
                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                "&:hover": {
                                  backgroundColor: "rgba(255, 255, 255, 1)",
                                },
                              }}
                              color="error"
                              size="small"
                            >
                              <DeleteIcon width="16px" height="16px" />
                            </IconButton>
                          </Box>
                        </ListItem>
                      )
                  )}
                </List>
              </Grid>

              <Grid item xs={12} md={12}>
                <Grid container direction="row" spacing={4}>
                  <Grid item xs={12} md={4}>
                    {/* <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    style={{ fontSize: "14px" }}
                  >
                    Add Location Name
                  </Typography> */}
                    <TextField
                      label="Add Location Name"
                      className="form-input"
                      fullWidth
                      placeholder=""
                      value={newLocationName}
                      name="locationName"
                      error={Boolean(errors.locationName)}
                      helperText={errors.locationName}
                      onChange={(e) => {
                        setErrors((prev) => ({
                          ...prev,
                          locationName: "",
                        }));
                        setNewLocationName(e.target.value);
                      }}
                    />
                    <FormControl component="fieldset" className="mt-1">
                      <FormControlLabel
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          margin: "0",
                        }}
                        value="on"
                        label="Open a new tab"
                        control={<Switch color="primary" />}
                        labelPlacement="on"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <FormControl fullWidth className="add-location-link">
                      <InputLabel>Add Location Link</InputLabel>
                      <Select
                        value={newLocationId || ""}
                        name="locationLink"
                        onChange={(e) => {
                          const selectedId = e.target.value;
                          const selected = locationPageList?.data?.find(
                            (option) => option._id === selectedId
                          );
                          if (selected) {
                            setErrors((prev) => ({ ...prev, locationLink: "" }));
                            setNewLocationLink(selected.canonical);
                            setNewLocationId(selected._id);
                          }
                        }}
                        className="form-select"
                        MenuProps={{
                          style: {
                            height: 400,
                          },
                        }}
                        label={"https://hyperwolf.com/w/cannabis-delivery..."}
                        error={Boolean(errors.locationLink)}
                        displayEmpty
                        renderValue={(selected) => {
                          const selectedOption = locationPageList?.data?.find(
                            (option) => option._id === selected
                          );
                          return selectedOption?.canonical || newLocationLink || "";
                        }}
                      >
                        {locationPageList?.data?.length > 0 &&
                          locationPageList?.data?.map((option, idx) => {
                            return (
                              <MenuItem value={option._id} key={idx + 1}>
                                {option?.city}
                              </MenuItem>
                            );
                          })}
                      </Select>
                      {Boolean(errors.locationLink) && (
                        <FormHelperText error>{errors.locationLink}</FormHelperText>
                      )}
                    </FormControl>
                    <FormControl component="fieldset" className="mt-1">
                      <FormControlLabel
                        style={{
                          display: "flex",
                          flexDirection: "row-reverse",
                          margin: "0",
                        }}
                        value="on"
                        label="Select from page list"
                        control={<Switch color="primary" />}
                        labelPlacement="on"
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Box display="flex" gap={1} alignItems="center">
                      <MDButton
                        type="button"
                        color="primary"
                        size="medium"
                        variant="outlined"
                        sx={{ minWidth: "125px", fontSize: "14px", minHeight: "47px" }}
                        onClick={addLocationHandler}
                      >
                        {isEdit ? (
                          <>
                            <Icon>edit</Icon>&nbsp;&nbsp;Update
                          </>
                        ) : (
                          <>
                            <Icon>add</Icon>&nbsp;&nbsp;Add
                          </>
                        )}
                      </MDButton>
                      {isEdit && (
                        <MDButton
                          type="button"
                          color="dark"
                          size="medium"
                          variant="outlined"
                          sx={{ minWidth: "125px", fontSize: "14px", minHeight: "47px" }}
                          onClick={() => {
                            setIsEdit(false);
                            setEditingLocationId(null);
                            setNewLocationName("");
                            setNewLocationLink("");
                            setNewLocationId("");
                            setErrors((prev) => ({
                              ...prev,
                              locationName: "",
                              locationLink: "",
                            }));
                          }}
                        >
                          Cancel
                        </MDButton>
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default FooterSection;
